// extracted by mini-css-extract-plugin
module.exports = {"signinTitle":"SignIn_signinTitle__24aLR","signinCardBody":"SignIn_signinCardBody__3i77z","spinner":"SignIn_spinner__15x_I","errorMessage":"SignIn_errorMessage__lQPKM"};